var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("activator",null,{"onClick":_vm.onClick}),_c('input',{key:_vm.inputKey,ref:"file",staticClass:"sr-only",attrs:{"type":"file","accept":"image/jpeg"},on:{"change":_vm.onInput}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }